import React from 'react';

import Tooltip from '../../common/Tooltip';

export const renderStatus = (
    published?: boolean | null,
    active?: boolean | null,
) => {
    if (active === false) {
        return (
            <Tooltip tooltip="This worker is disabled">
                <i className="icon icon-medium with-margin icon-help-circle grey" />
            </Tooltip>
        );
    }
    if (published === true) {
        return (
            <Tooltip tooltip="This worker is published and receives offers">
                <i className="icon icon-medium with-margin icon-check-circle-22 green" />
            </Tooltip>
        );
    }
    return (
        <Tooltip tooltip="This worker is not published">
            <i className="icon icon-medium with-margin icon-remove-circle-11 red" />
        </Tooltip>
    );
};

export const getSafeSelectedFilter = (
    selected: string | null,
    options: { value: string }[],
) => {
    if (!selected) {
        return '';
    }
    return options.some(option => option.value === selected) ? selected : '';
};
